import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Typography from '@material-ui/core/Typography';
import {styles} from '../CSS/Styles'


class SimpleSelect extends React.Component {
  state = {
      value: this.props.defaultoption
  };
  componentWillMount() {
  }

  componentDidMount() {

  }
  componentDidUpdate(prevprops) {
      if (this.props.defaultoption != prevprops.defaultoption) {
          this.setState({value:this.props.defaultoption})
      }
  }

  handleChange = (event) => {
    this.setState({ value: event.target.value },
    ()=>{
      this.props.returnSelection(this.props.id, this.props.option[this.state.value], this.props.index)})
  };

  render() {
    const { classes } = this.props;
    //console.log(this.props.defaultoption)
    return (
      <div>
        {this.props.header == null ? null :<Typography variant = "h7"  align="left" className={classes.FromSubHeader}> {this.props.header} </Typography>}

        <Select
            value={this.state.value}
            onChange={this.handleChange}
            name="value"
            className={classes.selectEmpty}
            style={{fontSize:'15px'}}
        >
          {this.props.option.map((option, index)=>{
            return(
              <MenuItem value={index}> {this.props.id == 'Risk Owners' || this.props.id == 'Supported by' ? option : option.split(', ')[0]} </MenuItem>
            )
          })}
        </Select>
      </div>
    );
  }
}

SimpleSelect.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SimpleSelect);


// WEBPACK FOOTER //
// ./src/components/CSSComponent/dropdownselection.js